import { useEffect } from "react";
import "@/App.css";

const REDIRECT_URL = "https://2tx1.com";

function App() {
  useEffect(() => {
    // Immediately send every visitor to the destination.
    window.location.replace(REDIRECT_URL);
  }, []);

  return (
    <div className="App" data-testid="redirect-page">
      <div className="redirect-card" data-testid="redirect-card">
        <div className="redirect-spinner" aria-hidden="true" />
        <h1 className="redirect-title" data-testid="redirect-title">
          Redirecting&hellip;
        </h1>
        <p className="redirect-text">
          Taking you to{" "}
          <a
            data-testid="redirect-link"
            className="redirect-link"
            href={REDIRECT_URL}
            rel="noopener noreferrer"
          >
            2tx1.com
          </a>
        </p>
        <p className="redirect-hint">
          If you are not redirected automatically, click the link above.
        </p>
      </div>
    </div>
  );
}

export default App;
